import React from "react";
import Button from 'react-bootstrap/Button'
import { formatNumber } from "../Utility";

export interface TableTotalProps {
    total?: number
}

export const TableTotal: React.FC<TableTotalProps> = (props: React.PropsWithChildren<TableTotalProps>) => {
    if (props.total == null)
        return <div></div>

    return <div className="table-summary-top table-summary-bottom d-flex justify-content-between p-2 form-content-preview">
        <b>Total:&nbsp;</b>
        <b>${formatNumber(props.total)}</b>
    </div>
}